import * as React from 'react';
import {TypeImplementation} from '@packages/systems/wfdl';
import {ExpressionEditor} from '@packages/systems/ExpressionEditor-utils';
import * as wq from '@packages/systems/wfdl-Qualified';
import {TText} from '@packages/systems/wfdl-ast';
import {TNonEmptyText, TOptionalText} from '@packages/systems/plugins/Text';
import {ContextualExpression} from '@packages/utilities/contextual-expression';

const render = ({
  expr,
  dispatch,
}: {
  expr: ContextualExpression;
  dispatch: TypeImplementation.ExpressionEditorDispatch;
}) => <ExpressionEditor expression={expr} dispatch={dispatch} />;

const icon = wq.qualify(wq.pluginName('Phone'), wq.iconName('Phone'));

const system = {bindUIVariant: 'custom'} as const;

export const PhoneType = TypeImplementation.Alias({
  type: TText,
  render,
  icon: TypeImplementation.IconByName(icon),
  system,
});

export const NonEmptyPhoneType = TypeImplementation.Alias({
  type: TNonEmptyText,
  render,
  icon: TypeImplementation.IconByName(icon),
  system,
});

export const OptionalPhoneType = TypeImplementation.Alias({
  type: TOptionalText,
  render,
  icon: TypeImplementation.IconByName(icon),
  system,
});
